import { Edit } from '@mui/icons-material';
import { Alert, IconButton } from '@mui/material';
import React, { useState } from 'react';
import Modal from '../../elements/Modal';
import ProductProviderForm from './ProductProviderForm';
import { editProductLinks } from '../../../api/products';

export default function EditProductLinks({
  fetchData,
  provider,
  token,
  setMessage,
  setSnackbarOpen,
}) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setError(null);
    try {
      const payload = {
        price: values.price.replace(/,/g, ''),
        reviewCount: values.reviewCount || 0,
        rating: values.rating || 0,
        reviewUrl: values.reviewUrl,
      };

      const response =  await editProductLinks(payload, provider.id, token);
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.error?.message || errorResponse.message);
      }
      setSnackbarOpen(true);
      setMessage('Store updated successfully');
      fetchData();
      handleClose();
    } catch (error) {
      setError(error.message || 'Failed to update store');
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setError(null);
  };

  return (
    <>
      <IconButton
        size="small"
        disableRipple
        onClick={handleClickOpen}>
        <Edit />
      </IconButton>
      <Modal
        open={open}
        modalTitle="Update links"
        handleClose={handleClose}
        width={'md'}>
        {error && (
          <Alert severity="error" sx={{ mb: '15px' }}>
            {error}
          </Alert>
        )}
        <ProductProviderForm
          onSubmit={handleSubmit}
          provider={provider}
          setError={setError}
          token={token}
          mode='edit'
        />
      </Modal>
    </>
  );
}
